import React from 'react'
// icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
// hooks
import { useRouter } from 'hooks/useRouter'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { Actions, Code, Content, Ghost, Logo, Page, Text, Title, Top } from './views'

const NotFound: React.FC = () => {
  const router = useRouter()

  // ProtectedRoute sends an unauthenticated user from /home on to /login
  const goHome = () => router.push('/home')
  const goBack = () => router.back()

  return (
    <Page>
      <Ghost aria-hidden='true'>404</Ghost>
      <Top>
        <Logo />
      </Top>
      <Content>
        <Code>Error 404</Code>
        <Title>Page not found</Title>
        <Text>
          The page you are looking for does not exist or has been moved.
          <br />
          Please check the address.
        </Text>
        <Actions>
          <Button layout={BUTTON_LAYOUTS.PURPLE_INVERTED} startIcon={<ArrowBackIcon />} onClick={goBack}>
            Go back
          </Button>
          <Button layout={BUTTON_LAYOUTS.PURPLE} startIcon={<HomeOutlinedIcon />} onClick={goHome}>
            Go to home page
          </Button>
        </Actions>
      </Content>
    </Page>
  )
}

export default NotFound
